import { useCallback } from "react"

import queryString from "query-string"

import { history } from "../../lib/history.web"
import { Params } from "../../navigation/routes"

export function useNavigate(): (
  path: string,
  params?: Params,
  // This is only applicable on native. It will have no effect here.
  mode?: string,
) => void {
  return useCallback((path, params) => {
    const currentPath = window.location.pathname + window.location.search

    const utmParameterNames = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ]

    const queryParams = queryString.parseUrl(currentPath).query

    const utmParams = Object.fromEntries(
      utmParameterNames.flatMap((utmParamName) =>
        queryParams[utmParamName]
          ? [[utmParamName, queryParams[utmParamName]]]
          : [],
      ),
    )

    const preservedParams = {
      ...(params || {}),
      ...utmParams,
    }

    const nextPath =
      path +
      (preservedParams ? "?" + queryString.stringify(preservedParams) : "")

    history.push(nextPath)
  }, [])
}
